import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, isRef as _isRef, withCtx as _withCtx, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tw-p-10 modal-member-detail" }
const _hoisted_2 = { class: "tw-flex tw-items-center tw-gap-[15px]" }
const _hoisted_3 = { class: "tw-text-[25px] tw-text-[#211F58] tw-font-[600] tw-leading-none" }
const _hoisted_4 = { class: "tw-text-[#211F58] tw-text-[15px] tw-not-italic tw-font-normal tw-leading-[145%]" }
const _hoisted_5 = {
  href: "#",
  class: "tw-underline tw-text-[#387DFF] tw-text-[15px]"
}
const _hoisted_6 = { class: "input-container email-container tw-flex" }
const _hoisted_7 = { class: "input-container tw-grow tw-flex-1" }
const _hoisted_8 = { class: "input-container email-container tw-flex" }
const _hoisted_9 = { class: "input-container tw-grow tw-flex-1" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-container tw-mx-[16px] tw-leading-[56px]" }, "@", -1)
const _hoisted_11 = { class: "dropdown-container tw-flex-1 dropdown" }
const _hoisted_12 = { class: "button-container tw-flex tw-justify-end tw-mt-[40px]" }

import store from "../../../store";
import utilities, {
  IsSpecialCharEmailNameValid,
  IsSpecialCharEmailNameValidWhieTyping,
  IsSpecialCharNameValid,
  getComponentUiText,
} from "../../../utils/utilities";
import {
  computed,
  reactive,
  ref,
  watch,
  Ref,
  onBeforeMount,
  onUpdated,
} from "vue";

import Modal from "../../common/modal.vue";
import ModalHeader from "../../common/modalHeader.vue";
import NoteInfo from "../../../components/common/noteInfo.vue";
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import {
  getOrgDomains,
  postOrgMemberCreate,
  postOrgDomainVerifyById,
} from "@/services/org";
import { IOrgDetails } from "@/interfaces/orgInterfaces";
import BaseInput from "@/components/common/form/baseInput.vue";
import BaseDropDown from "@/components/common/form/baseDropDown.vue";
import BaseMultiDropDown from "@/components/common/form/baseMultiDropDown.vue";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import { IDropDownData } from "@/interfaces/common/IDropDown";
import BaseForm from "@/components/common/form/baseForm.vue";
import { showErrorAPI } from "@/services/apiRoutes";
import { Org } from "@/services/apiRoutes/routes";
import { IModalMessage } from "@/interfaces/common/common";
import { ExceptionTypes, MODAL_NAME } from "@/utils/constants";
import { IOrgRole } from "@/interfaces/org/role";
import { LottieAnimation } from "lottie-web-vue";
import ProgressAnimation from "@/assets/animation/progress_dark.json";
const DEFAULT_MAX_WIDTH_MODAL = 65;

const cssFieldEmail =
  "form-control input-base-form-input tw-gap-2.5 tw-border tw-text-[#231F20] tw-text-[15px] tw-leading-none tw-pl-[25px] tw-pr-[45px] tw-py-[20px] tw-rounded-md tw-border-solid tw-border-[#EFF0F1] tw-bg-[#FFFFFF]";
const CUSTOM_CLASS_INPUT_INVALID = "is-invalid";

export default /*#__PURE__*/_defineComponent({
  __name: 'memberDetailsModal',
  props: {
  show: {
    type: Boolean,
    required: false,
  },
},
  emits: ["update:show", "add:member"],
  setup(__props, { emit }) {

const props = __props;

const memberRoles: Ref<IDropDownData[]> = computed(() => {
  const orgRoles: IOrgRole[] = store.state.Org.orgRoles;
  return orgRoles.map((item) => {
    return {
      id: item.roleId,
      name: item.roleName,
    };
  });
});
const domainSelectOptions: Ref<IDropDownData[]> = ref([]);
const customClassInputEmail = ref(cssFieldEmail);
const showLoadingSubmitButton: Ref<boolean> = ref(false);





const focusEmailName = ref(false);

const initialForm = {
  name: "",
  email: "",
  domainId: "",
  title: "",
  roles: [],
  roleIds: [],
};
// Form modal and validation.
const formModel = reactive({ ...initialForm });

const rules = {
  name: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
    IsSpecialCharNameValid: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-team-members-organisation-modal-name-invalid-error-1",
        ),
      IsSpecialCharNameValid,
    ),
  },
  email: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
    specialChar: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-team-members-organisation-modal-email-error-1",
        ),
      IsSpecialCharEmailNameValidWhieTyping,
    ),
    email: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-team-members-organisation-modal-email-error-1",
        ),
      IsSpecialCharEmailNameValid,
    ),
  },
  domainId: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
  },
  title: {},
  roles: {},
  roleIds: {},
};

const $v = useVuelidate(rules, formModel);
let showRef = ref(props.show);
let notInfoVisible = ref(true);

const orgDetails: Ref<IOrgDetails> = computed(
  () => store.getters["Org/getOrgDetails"],
);
const getFormData = async () => {
  if (orgDetails.value.id) {
    try {
      const domainResponse = await getOrgDomains(orgDetails.value.id);
      if (
        domainResponse?.data?.data &&
        Array.isArray(domainResponse.data.data?.domains)
      ) {
        if (domainResponse?.data?.data.domains.length === 1) {
          formModel.domainId = domainResponse?.data?.data.domains[0].domainId;
        }
        domainSelectOptions.value = domainResponse.data.data?.domains
          .filter((item) => !!item.isVerifiedEmail)
          .map((item) => {
            return {
              id: item.domainId,
              name: item.domain,
              domain: item.domain,
            };
          });
      }
    } catch (error: any) {
      if (error && error.data) {
        showErrorAPI(error, Org.getDomains);
      }
    }
  }
};

const isDisableCheckName: Ref<boolean> = ref(true);

const handleUpdateCssInput = async () => {
  await $v.value.name.$validate();
  if (formModel.name && utilities.IsSpecialCharNameValid(formModel.name)) {
    customClassInputEmail.value = cssFieldEmail;
  } else {
    customClassInputEmail.value = `${cssFieldEmail} ${CUSTOM_CLASS_INPUT_INVALID}`;
  }
};

const updateValueInputFiled = () => {
  if (isDisableCheckName.value) return;
  handleUpdateCssInput();
};

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
    if (value) initial();
    else clearWatchAndListener();
  },
);

watch(orgDetails, getFormData, { deep: true });

onBeforeMount(() => {
  getFormData();
});

onUpdated(() => {
  getFormData();
});

const initial = () => {
  notInfoVisible.value = true;
  customClassInputEmail.value = cssFieldEmail;
  listeningEvent();
};

const listeningEvent = () => {
  EventEmitter.on(EmitterEvents.EVENT_KEYBOARD_ENTER, () => onSubmit());
};

const clearWatchAndListener = () => {
  EventEmitter.off(EmitterEvents.EVENT_KEYBOARD_ENTER);
};

const defaultUiText = computed(() => store.state.LanguagePicker.defaultUiText);
const languageSelectedText = computed(
  () => store.state.LanguagePicker.languageSelectedText,
);
const getUiText = (id: string, isArray = false) => {
  return utilities.getUiText(
    id,
    languageSelectedText.value,
    defaultUiText.value,
    isArray,
  );
};

const successMessage = getUiText(
  "app-settings-team-members-organisation-modal-add-org-member-success-1",
);

const secretRequiredPasswordReset = computed(
  () => store.state.Org.currentOrgSecretRequired?.secretRequiredPasswordReset,
);

const onSubmit = async () => {
  await $v.value.$validate();
  isDisableCheckName.value = false;
  handleUpdateCssInput();
  if ($v.value.$invalid) return;

  showLoadingSubmitButton.value = true;

  try {
    const dataCreate = {
      ...(utilities.getFirstAndLastNameFromName(formModel.name) as {
        firstName: string;
        lastName: string;
      }),
      email: `${formModel.email}@${getDomainFromId()}`,
      title: formModel.title,
      requireMFA: false,
      ...(formModel.roleIds.length
        ? {
            roleIds: formModel.roleIds.map(
              (item: number | string) => `${item}`,
            ),
          }
        : {}),
    };
    const formResponse: any = await postOrgMemberCreate(dataCreate);
    if (formResponse.data?.data) {
      onShowToast(successMessage, ToastVariant.SUCCESS);
      const data = {
        ...(utilities.getFirstAndLastNameFromName(formModel.name) as {
          firstName: string;
          lastName: string;
        }),
        secretKey: formResponse.data?.data.secret,
      };
      if (secretRequiredPasswordReset.value) {
        EventEmitter.emit(EmitterEvents.ORG_MEMBER_CREATED, data);
      }
      emit("add:member");
      handleCloseModal();
    }
  } catch (error: any) {
    if (error && error.data) {
      if (error.data.error.type === ExceptionTypes.EmailDomainNotVerified) {
        showVerifyModal(
          getDomainFromId(),
          formModel.domainId,
          `${formModel.email}@${getDomainFromId()}`,
        );
      } else {
        showErrorAPI(error, Org.createMember);
      }
    }
  } finally {
    showLoadingSubmitButton.value = false;
  }
};

const showVerifyModal = (domain, domainId, email) => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
    properties: {
      value: {},
      title: getComponentUiText(
        "app-settings-organisation-member-domain-unverify-modal-title-1",
      ),
      description: getComponentUiText(
        "app-settings-organisation-member-domain-unverify-modal-description-1",
        false,
        { domain },
      ),
      buttonText: getComponentUiText(
        "app-settings-organisation-member-domain-unverify-modal-button-1",
      ),
      buttonRed: false,
      hiddenHelp: false,
    },
    events: {
      "update:data": async () => {
        try {
          handleCloseModal();
          const formResponse: any = await postOrgDomainVerifyById(
            domainId,
            email,
          );
          if (formResponse.data?.data) {
            onShowToast(
              getUiText(
                "app-settings-organisation-member-domain-unverify-modal-message-1",
              ),
              ToastVariant.SUCCESS,
            );
          }
        } catch (error: any) {
          if (error && error.data) {
            showErrorAPI(error, Org.orgDomainVerify);
          }
        }
      },
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const onShowToast = (messageError: string, variant: ToastVariant) => {
  const emitData: IToastMessage = { variant, message: messageError };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

const getDomainFromId = () => {
  const domain = domainSelectOptions.value.find(
    (domain) => domain.id === formModel.domainId,
  );
  return domain ? domain.domain : "";
};
const clearData = () => {
  for (const key in formModel) {
    if (Array.isArray(formModel[key])) {
      formModel[key].splice(0); // Clear the array content while maintaining reference
    } else {
      formModel[key] = initialForm[key];
    }
  }
  $v.value.$reset();
};

const handleInputEmail = (val: string) => {
  if (val.trim() === "") $v.value.email.$reset();
  else {
    $v.value.email.$touch();
    $v.value.email.$model = val;
  }
};

const handleCloseModal = (fromModal = false) => {
  if (
    (formModel.name ||
      formModel.email ||
      formModel.title ||
      formModel.roles.length ||
      formModel.roleIds.length ||
      formModel.domainId) &&
    fromModal
  )
    return;
  clearData();
  showRef.value = false;
  emit("update:show", showRef.value);
};

return (_ctx: any,_cache: any) => {
  const _component_BFormInput = _resolveComponent("BFormInput")!
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createBlock(Modal, {
    class: "tw-translate-y-[-50%] member-details-modal",
    "max-width": DEFAULT_MAX_WIDTH_MODAL,
    value: formModel,
    visible: _unref(showRef),
    onClose: _cache[12] || (_cache[12] = ($event: any) => (handleCloseModal(true)))
  }, {
    default: _withCtx(() => [
      _createVNode(ModalHeader, {
        class: "modal-header",
        title: getUiText('app-settings-team-members-organisation-modal-title-1'),
        onClose: handleCloseModal
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(getUiText(
              "app-settings-team-members-organisation-modal-sub-title-1",
            )), 1)
        ]),
        _createVNode(NoteInfo, {
          class: "tw-mt-[20px] tw-mb-[25px]",
          onClose: _cache[0] || (_cache[0] = () => (_isRef(notInfoVisible) //@ts-ignore
 ? notInfoVisible.value = false : notInfoVisible = false))
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_4, _toDisplayString(getUiText("app-settings-team-members-organisation-modal-note-1")), 1),
            _createTextVNode("  "),
            _createElementVNode("a", _hoisted_5, _toDisplayString(getUiText("app-settings-team-members-tip-top-link-text-1")), 1)
          ]),
          _: 1
        }),
        _createVNode(BaseForm, {
          "enter-event": true,
          show: _unref(showRef),
          onOnSubmit: onSubmit
        }, {
          default: _withCtx(() => [
            _createVNode(BaseInput, {
              id: "name",
              modelValue: formModel.name,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formModel.name) = $event)),
              validation: _unref($v).name,
              label: _unref(getComponentUiText)('app-manage-orgs-name-text-1'),
              placeholder: 'Bob Michaels'
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_BFormInput, {
                      modelValue: formModel.name,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formModel.name) = $event)),
                      type: "text",
                      placeholder: 
                  _unref(getComponentUiText)(
                    'app-setting-team-member-detail-fullname-placeholder-1',
                  )
                ,
                      class: _normalizeClass([[
                  customClassInputEmail.value,
                  _unref($v).name.$error ? 'is-invalid' : '',
                ], "autoFocus"]),
                      onBlur: _cache[2] || (_cache[2] = () => _unref($v).name.$touch()),
                      onInput: updateValueInputFiled
                    }, null, 8, ["modelValue", "placeholder", "class"])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "validation", "label"]),
            _createVNode(BaseInput, {
              id: "email",
              modelValue: formModel.email,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formModel.email) = $event)),
              validation: _unref($v).email,
              "is-focus-slot": focusEmailName.value,
              label: _unref(getComponentUiText)('app-user-profile-form-label-email-1'),
              placeholder: 
            getUiText(
              'app-settings-team-members-organisation-modal-form-placeholder-title',
            )
          
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_BFormInput, {
                      modelValue: formModel.email,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formModel.email) = $event)),
                      type: "text",
                      placeholder: 
                  _unref(getComponentUiText)(
                    'app-setting-team-member-detail-username-placeholder-1',
                  )
                ,
                      class: _normalizeClass([
                  'form-control input-base-form-input',
                  _unref($v).email.$error &&
                  (!focusEmailName.value ||
                    _unref($v).email.$errors[0].$validator !== 'email')
                    ? 'is-invalid'
                    : '',
                ]),
                      state: _unref($v).email.dirty ? _unref($v).email.$error : null,
                      onInput: handleInputEmail,
                      onBlur: _cache[5] || (_cache[5] = 
                  () => {
                    _unref($v).email.$touch();
                    focusEmailName.value = false;
                  }
                ),
                      onFocus: _cache[6] || (_cache[6] = () => (focusEmailName.value = true))
                    }, null, 8, ["modelValue", "placeholder", "class", "state"])
                  ]),
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(BaseDropDown, {
                      id: 'domain',
                      modelValue: formModel.domainId,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formModel.domainId) = $event)),
                      data: domainSelectOptions.value,
                      validation: _unref($v).domainId,
                      "class-name": 'gray-dropdown-container tw-h-[58px]',
                      placeholder: 
                  getUiText('app-component-custom-b-dropdown-prompt-email-1')
                
                    }, null, 8, ["modelValue", "data", "validation", "placeholder"])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "validation", "is-focus-slot", "label", "placeholder"]),
            _createVNode(BaseInput, {
              id: "title",
              modelValue: formModel.title,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formModel.title) = $event)),
              validation: _unref($v).title,
              label: 
            _unref(getComponentUiText)('app-component-custom-b-dropdown-label-title-1')
          ,
              placeholder: 
            getUiText(
              'app-settings-team-members-organisation-modal-form-placeholder-title',
            )
          
            }, null, 8, ["modelValue", "validation", "label", "placeholder"]),
            _createVNode(BaseInput, {
              id: "roleIds",
              modelValue: formModel.roleIds,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formModel.roleIds) = $event)),
              validation: _unref($v).roleIds,
              label: 
            _unref(getComponentUiText)('app-component-custom-b-dropdown-label-roles-1')
          
            }, {
              default: _withCtx(() => [
                _createVNode(BaseMultiDropDown, {
                  id: 'dropdownIcon',
                  modelValue: formModel.roleIds,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formModel.roleIds) = $event)),
                  data: memberRoles.value,
                  validation: _unref($v).roleIds,
                  "class-name": 'member-detail-dropdown gray-dropdown-container tw-min-h-[58px] tw-text-[#FFFFFF]',
                  placeholder: 
              _unref(getComponentUiText)(
                'app-component-custom-b-dropdown-prompt-roles-1',
              )
            
                }, null, 8, ["modelValue", "data", "validation", "placeholder"])
              ]),
              _: 1
            }, 8, ["modelValue", "validation", "label"]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_b_button, {
                variant: "primary",
                class: "button-verify tw-bg-[#387DFF] tw-h-[39px] tw-py-0 tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]",
                onClick: onSubmit
              }, {
                default: _withCtx(() => [
                  (showLoadingSubmitButton.value)
                    ? (_openBlock(), _createBlock(_unref(LottieAnimation), {
                        key: 0,
                        class: _normalizeClass('tw-h-[41px] tw-w-full'),
                        "animation-data": _unref(ProgressAnimation),
                        "auto-play": true,
                        loop: true
                      }, null, 8, ["animation-data"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, _toDisplayString(getUiText(
                  "app-settings-team-members-organisation-modal-invite-button-1",
                )), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["show"])
      ])
    ]),
    _: 1
  }, 8, ["value", "visible"]))
}
}

})